// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"049aa8ed","97":"6c4854f0","330":"c91b6151","331":"7ee548ec","453":"8719308d","574":"175c31e1","622":"e58f233e","675":"2695e2db","774":"27a45d8f","835":"99587355"}[chunkId] + ".chunk.js";
};